export const SENSITIVE_MODULES = {
  PROMOTION: "promotion",
  COUPON_GROUP: "coupon-group",
  COUPON: "coupon",
  ADMIN_USER: "admin-user",
}

export const SEND_SENSITIVE_ACTION_OTP = "admin/sensitive-action/send-otp"

